import { AxiosResponse } from 'axios';
import { getNameRegister } from 'civil-status/components/shared/list-register';
import { getNameTypeContent } from 'civil-status/constants/id-type-content';
import { ActListVM } from 'civil-status/view-models/research-category-form';
import { DateTime } from 'luxon';
import { ActCategory, ConsultazioneANSCResponse } from 'shell/models/act-category-list';
import { HttpResponse } from 'shell/models/http-response';

export const transformerActCategoryList = (
  response: AxiosResponse<HttpResponse<ActCategory>>,
  isListActFromPerson?: boolean
): Array<ActListVM> => {
  const castedRes = response.data?.payload as ActCategory;

  const listResponse = (response.data?.payload.consultazioneANSCResponse ||
    {}) as unknown as ConsultazioneANSCResponse;

  const listResponseSoggetti = (response.data?.payload ||
    {}) as unknown as ConsultazioneANSCResponse;

  const totalCount =
    listResponse?.datiPaginazione?.numRecordTotali ||
    listResponseSoggetti?.datiPaginazione?.numRecordTotali ||
    0;

  if (
    listResponse?.modelEventoDTO?.length ||
    ((isListActFromPerson || !listResponseSoggetti?.soggetti?.length) &&
      listResponseSoggetti?.modelEventoDTO?.length)
  ) {
    // ricerca per atto
    return (listResponse?.modelEventoDTO || listResponseSoggetti?.modelEventoDTO || [])?.map(
      (item) => ({
        totalCount,
        holders: (item.intestatari || [])
          .map((intestatario) => `${intestatario.nome || ''} ${intestatario.cognome || ''}`)
          .join(', '),
        register: getNameRegister(item.idTipoEvento),
        typology: item.descrizioneCasoUso || '',
        dateFormation: item.dataformazione
          ? DateTime.fromISO(item.dataformazione).toFormat('dd/MM/yyyy')
          : '',
        idSubject: item.id || '',
        idAnsc: item.idAnsc || '',
        municipality: `${item.nomeComuneRegistrazione || ''} ${
          item.siglaProvinciaRegistrazione ? `(${item.siglaProvinciaRegistrazione})` : ''
        }`,
        state: item.stato || '',
        typeContent: getNameTypeContent(item.idtipocontenuto),
        itemSaved: item,
        datiAggiuntiviSide: castedRes.datiAggiuntiviSide,
      })
    );
  }

  if (listResponseSoggetti?.soggetti?.length) {
    // ricerca per persona
    return (listResponseSoggetti?.soggetti || []).map((item) => ({
      totalCount,
      name: item.nome || '',
      surname: item.cognome || '',
      idAnsc: item.id || '',
      fiscalCode: item.codiceFiscale || '',
      state: item.nomeStatoNascita || '',
      municipality: `${item.nomeComuneNascita || ''} ${
        item.siglaProvinciaNascita ? `(${item.siglaProvinciaNascita})` : ''
      }`,
      dateBorn: item.dataNascita ? DateTime.fromISO(item.dataNascita).toFormat('dd/MM/yyyy') : '',
      isResearchPerson: true,
    }));
  }

  return [];
};
